/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("settlementManagementModule", []).
controller("settlementManagementCtrl", ["$scope", "$q", "$element", "$validation", "httpService", "modalDialog", function($scope, $q, $element, $validation, httpService, modalDialog) {
    initStatus();
    initData();
    /**
     * [selectBank description] 选择银行回调
     * @return {[type]} [description]
     */
    $scope.selectBank = function() {
        if (!$scope.status.selectedBank.value) {
            delete $scope.status.selectedBank;
        }
       $scope.status.selectedBank.value== 0 ? $element.find('trs-single-select button span:first-child').removeClass('textColor') : $element.find('trs-single-select button span:first-child').addClass('textColor');
        
    };

    function initStatus() {
        $scope.data = {
            bankName: '',
            cardNumber: '',
            alipay: ''
        };
        $scope.status = {
            bankOptions: [],
            selectedBank:''
        };
        initDropDownList();
        power();
    }

    function initData() {
        loadEncryptionLib().then(function() {
            encryptionMethods();
        });
    }

    function initDropDownList() {
        $scope.status.bankOptions = [{
            name: "选择开户银行",
            value:0,
        }, {
            name: "工商银行",
            value: 1,
        }, {
            name: "农业银行",
            value: 2,
        }, {
            name: "中国银行",
            value: 3,
        }, {
            name: "建设银行",
            value: 4,
        }, {
            name: "交通银行",
            value: 5,
        }, {
            name: "上海浦东发展银行",
            value: 6,
        }, {
            name: "兴业银行",
            value: 7,
        }, {
            name: "光大银行",
            value: 8,
        }, {
            name: "深圳发展银行",
            value: 9,
        }, {
            name: "民生银行",
            value: 10,
        }, {
            name: "中信银行",
            value: 11,
        }, {
            name: "招商银行",
            value: 12,
        }, {
            name: "广东发展银行",
            value: 13,
        }, {
            name: "华夏银行",
            value: 14,
        }];
        $scope.status.selectedBank = angular.copy($scope.status.bankOptions[0]);
    }
    /**
     * [encryptionMethods description] 加密方法
     * @return {[type]} [description]
     */
    function encryptionMethods() {
        $.ajax({
            url: "/mcnww/web/user/publicKey.do",
            // headers:{requestToken:sessionStorage.getItem('requestToken'),"Content-Type":"text/plain;charset=UTF-8"},
            dataType: "text",
            success: function(data) {
                $("#encryption").remove();
                $("body").append("<script id='encryption'>" + data + "</script>");
            }
        });
    }
    /**
     * [loadEncryptionLib description] 加载加密依赖文件
     * @return {[type]} [description]
     */
    function loadEncryptionLib() {
        var deffer = $q.defer();
        LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [loadEncryptionLib description] 加载加密依赖文件
     * @return {[type]} [description]
     */
    $scope.savePwd = function() {
        $validation.validate($scope.changePwdForm).success(function() {
            savePwd();
        }).error(function() {
            angular.invalidPosition($scope.changePwdForm, $element);
        });
    };

    function savePwd() {
        var selectedBank = '';
        if($scope.status.selectedBank == undefined){
            selectedBank = '';
        }else{
            selectedBank = $scope.status.selectedBank.value;
        }
        var params = {
            bankName: selectedBank,
            bankCardNumber: $scope.data.cardNumber,
            alipayCode: $scope.data.alipay
        };
        httpService.http("/mcnww/web/ucenter/updatePayAccount.do", params, "post").then(function(result) {
            modalDialog.success("银行卡修改成功", "success", false, function() {});
        });
    }
    //获取卡号
    function power() {
        httpService.http("/mcnww/web/user/getLoginUser.do", "", "post").then(function(data) {
            var bankArry = angular.copy($scope.status.bankOptions);
            var Newjson = {}
            for (var i = 0; i < bankArry.length; i++) {
                if (bankArry[i].value == data.loginUser.bankName) {
                    Newjson.name = bankArry[i].name;
                    Newjson.value = bankArry[i].value;
                }
            }
            $scope.status.selectedBank = Newjson;
            $scope.power = data.loginUser.bankName;
            $scope.data.cardNumber = data.loginUser.bankCardNumber;
            $scope.data.alipay = data.loginUser.alipayCode;
        });
    }
}]);